import Link from "../../Link";

const React = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/1" title={"OpenBootcamp React Básico"} />
            <Link url="https://campus.open-bootcamp.com/cursos/4" title={"OpenBootcamp React Avanzado"} />
        </div>
    );
}

export default React;